import{__require as r}from"../helpers/isAbsoluteURL.js";import{__require as e}from"../helpers/combineURLs.js";var i,s;function o(){if(s)return i;s=1;var o=r(),t=e();return i=function(r,e){return r&&!o(e)?t(r,e):e}}export{o as __require};
